module.exports = __webpack_public_path__ + "img/img2.75b52652.jpg";